<section class="section section-why">
    <div class="container">
        <div class="section-header center">
            <div class="header-start">
                <h5 class="subtitle">Why mobileWISE For your next app release</h5>
                <h2 class="title">Faster deployment, <br>
                    with complete customization and 24X7 support</h2>
            </div>
        </div>

        <div class="row g-3 g-xl-5">
            <div class="col-lg-4">
                <div class="support-item">
                    <div class="icon">
                        <mat-icon>schedule</mat-icon>
                    </div>
                    <h3>5 Minutes*</h3>
                    <p>You can deploy project</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="support-item">
                    <div class="icon">
                         <mat-icon class="material-icons-outlined" >space_dashboard</mat-icon>
                    </div>
                    <h3>200+</h3>
                    <p>Predesign components</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="support-item">
                    <div class="icon">
                        <mat-icon>vertical_split</mat-icon>
                    </div>
                    <h3>Limitless</h3>
                    <p>Possibilities & Customization</p>
                </div>
            </div>
           
        </div>
    </div>
</section>